import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { toRef, toValue, type MaybeRefOrGetter } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SiteQueryKeys } from "@/data/api/site-query-keys";
import { SiteProgrammingRangeQueryKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-query-keys";
import { SiteSectionMutationKeys } from "@/data/api/v4b/site-section/site-section-mutation-keys";
import { SiteSectionCategoryId, V4HSiteId } from "@/data/common/ids";
import { UpdateSectionCategoryRequest } from "@/domains/v4b/site-section/site-section.types";

export function useUpdateSectionCategoryMutation(siteId: MaybeRefOrGetter<V4HSiteId>) {
  const v4b = useServices().v4b.clientSdk;
  const queryClient = useQueryClient();
  const _siteId = toRef(siteId);

  return useMutation({
    mutationKey: SiteSectionMutationKeys.updateCategory(_siteId),
    mutationFn: (command: UpdateSectionCategoryRequest & { id: SiteSectionCategoryId }) => {
      return v4b.siteSectionCategory.update(toValue(siteId), command.id, { name: command.name });
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: SiteQueryKeys.sections(_siteId),
      });

      await queryClient.removeQueries({
        queryKey: SiteProgrammingRangeQueryKeys.findPlanning(_siteId),
      });
    },
    retry: 0,
  });
}
